import { Component, OnInit, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ListasService } from './listas.service';
import { CommonModule } from '@angular/common';
import { AlertComponent } from '../../../alert/alert.component';
import { LoadingModalComponent } from '../../../loading-modal/loading-modal.component';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subject,takeUntil  } from 'rxjs';
@Component({
  selector: 'app-listas',
  standalone: true,
  imports: [MatIconModule, CommonModule, ReactiveFormsModule, AlertComponent, LoadingModalComponent],
  templateUrl: './listas.component.html',
  styleUrls: ['./listas.component.scss'],
  providers: [ListasService]
})
export class ListasComponent implements OnInit {
  //Variaveis de loading e alerta
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent !: LoadingModalComponent;

  private unsubscribe$ = new Subject<void>();


  //Variaveis para a listagem das listas
  public listListas: Array<any> = [];

  //Variaveis do modal de insercao de uma nova lista
  public modalInserirLista: boolean = false;
  public formInserirLista!: FormGroup;



  //Variaveis para a insercao manual
  public formInputManual: FormGroup;


  //Variaveis para modal de importar arquivo 
  public modalImportFileCsv: boolean = false;
  public formImportFileCsv!: FormGroup;

  //Variaveis para o modal de visualizar os numeros
  public modalViewNumbersInList: boolean = false;
  public listNumbersInList: Array<any> = [];

  constructor(private listasService: ListasService, private fb: FormBuilder) {
    this.formInputManual = this.fb.group({
      idList: ['',[Validators.required]],
      nome: ['',[Validators.required]],
      number: ['',[Validators.required]]
    })
  }

  ngOnInit() {
    this.getListas();
  }

  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public trackByIdLista(index: number, id: number): number {
    return index;
  }


  public getListas() {
    this.listasService.getListas().subscribe((response: any) => {
      this.listListas = response;
    }, (error: any) => {
      console.log(error);
    })
  }

  public handleDeleteLista(idList: number, index: number) {
    this.loadingComponent.activeLoading();
    this.listasService.deleteLista(idList).subscribe((response: any) => {
      this.listListas.splice(index, 1);
      this.alertComponent.showAlert('Fila deletada com sucesso!', 'success');
      this.loadingComponent.inactiveLoading();

      this.getListas();
    }, (error: any) => {
      console.log(error);
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert(`Erro ao tentar deletar lista: ${error.error.status}`);
    })
  }

  //Funcoes do modal de inserir uma nova lista
  public openModalInserirNovaLista() {
    this.modalInserirLista = true;
    this.formInserirLista = this.fb.group({
      nome: ['', [Validators.required]]
    });
  }

  public closeModalInserirNovaLista() {
    this.modalInserirLista = false;
    this.formInserirLista.reset();
  }

  public onHandleSubmitAdicionarLista() {
    this.loadingComponent.activeLoading();
    this.listasService.setLista(this.formInserirLista.value).subscribe((response: any) => {
      this.listListas.unshift(this.formInserirLista.value);
      this.alertComponent.showAlert('Lista cadastrada com sucesso!', 'success');
      this.closeModalInserirNovaLista();
      this.loadingComponent.inactiveLoading();

      //Processar em segundo plano
      this.getListas();
    }, (error: any) => {
      console.log(error);
    })
  }



  //The functions of view numbers in list
  public trackByIdNumberList(index: number, id: number): number {
    return index;
  }


  public openModalViewNumbersInList(idList: number) {
    this.loadingComponent.activeLoading();

    this.listasService.getNumbersInLista(idList).subscribe((response: any) => {
      this.listNumbersInList = response;
      this.loadingComponent.inactiveLoading();
      this.modalViewNumbersInList = true;
    }, (error: any) => {
      console.log(`Erro ao tentar buscar numeros em lista : ${error.error}`)
    })
  }

  public closeModalViewNumbersInList() {
    this.modalViewNumbersInList = false;
  }

  public deleteNumberInList(indexContact: number) {
    this.loadingComponent.activeLoading();
    this.listasService.deleteNumberInLista(this.listNumbersInList[indexContact].id).subscribe((response: any) => {
      this.alertComponent.showAlert('Numero removido da lista com sucesso!', 'success');
      this.listNumbersInList.splice(indexContact, 1);
      this.loadingComponent.inactiveLoading();
    }, (error: any) => {
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert(`Erro ao tentar excluir numero ${error.error.status}`);
    })
  }

  public convertObjectsToCSV(array: Array<any>) {
    const header = 'ID,NOME,NUMERO';
    const csv = array.map(obj => `${obj.id || ''},${obj.nome || ''},${obj.numero || ''}`).join('\n');
    return header + '\n' + csv;
  }

  public downloadCSV(csv: string, nameFile: string) {
    const link = document.createElement('a');
    link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv));
    link.setAttribute('download', `${nameFile}.csv`);
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  public downloadListNumber(idLista: number, nameLista: string) {
    this.loadingComponent.activeLoading();
    this.listasService.getNumbersInLista(idLista).subscribe((response: any) => {
      const csvData = this.convertObjectsToCSV(response);
      this.downloadCSV(csvData, nameLista);
      this.loadingComponent.inactiveLoading();
    })
  }

  //The functions of modal import file csv

  public openModalImportFileCsv() {
    this.modalImportFileCsv = true;
    this.formImportFileCsv = this.fb.group({
      fileCsv: ['', [Validators.required]],
      idList: ['', [Validators.required]]
    })
  }

  public closeModalImportFileCsv() {
    this.modalImportFileCsv = false;
  }

  public handleSubmitImportFileCsv() {
    this.loadingComponent.activeLoading();
    this.listasService.setFileCsvInLista(this.formImportFileCsv.value).pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((response: any)=> {
      this.alertComponent.showAlert('Arquivo importado com sucesso!','success');
      this.loadingComponent.inactiveLoading();
      this.modalImportFileCsv = false;
    }, (error:any)=> {
      console.log(error);
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert('Erro ao tentar fazer upload do arquivo.','error');
    })
  }

  public handleFileInput(event: Event) {
    const file: any = (event?.target as HTMLInputElement).files?.[0];
    
    if(file){
      this.converToBase64(file);
    }
  }
  
  public removeFileCsv(){
    this.formImportFileCsv.patchValue({
      fileCsv: ''
    })
    const inputElement = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = ''; // Limpar o valor do input de arquivo
    }
  }

  private converToBase64(file: any){
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const base64String: string = e.target.result;
      this.formImportFileCsv.get('fileCsv')?.setValue(reader.result?.slice(21));
    };
    reader.readAsDataURL(file);
  }

  //the functions of insertions manualy
  public handleSubmitInputManual(){
    this.loadingComponent.activeLoading();
    this.formInputManual.get('number')?.setValue(this.formInputManual.value.number.replace(/[^0-9]/g, ""));
    this.listasService.setNumberInFilaManualy(this.formInputManual.value).pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((reponse: any)=> {
      this.alertComponent.showAlert('Cliente adicionado a lista com sucesso!', 'success');
      this.formInputManual.reset();
      this.loadingComponent.inactiveLoading();
    }, (error: any)=> {
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert(`Erro ao tentar inserir cliente a lista: ${error.error.status}`)
    })
  }

  public handleMaskPhone(){
    const numeroLimpo = this.formInputManual.value.number.replace(/\D/g, '');

    // Verifica se o número tem 11 dígitos (incluindo DDD) e formata
    if (numeroLimpo.length === 11) {
        this.formInputManual.patchValue({
          number: `(${numeroLimpo.substr(0, 2)}) ${numeroLimpo.substr(2, 5)}-${numeroLimpo.substr(7)}`
        });
    } else if (numeroLimpo.length === 10) {
      this.formInputManual.patchValue({
        number:  `(${numeroLimpo.substr(0, 2)}) 9${numeroLimpo.substr(2, 4)}-${numeroLimpo.substr(6)}`
      })
  }
  }
}
